var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button } from '@chakra-ui/react';
import styled from '@emotion/styled';
import BEIcon from '@molecules/BEIcon';
import { useAppSize } from '@view/hooks/useAppSize';
const StyledCloseButton = styled(Button) `
  position: absolute;
  width: var(--booking-engine-space-12);
  height: var(--booking-engine-space-12);
  background-color: #FFFFFF;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  z-index: 999;

  &::selection {
    border: none;
  }

  &:focus {
    background-color: #F5F5F5;
  }

  &:hover {
    background-color: #F5F5F5;
  }
`;
const CloseButton = (_a) => {
    var { onClick, testid } = _a, props = __rest(_a, ["onClick", "testid"]);
    const { size } = useAppSize();
    const { t } = useTranslation();
    return (_jsx(StyledCloseButton, Object.assign({ "aria-label": t('close'), "data-testid": testid, onClick: onClick, variant: "ghost" }, props, { children: _jsx(BEIcon, { "aria-hidden": true, name: "close", size: size, weight: "solid" }) })));
};
export default CloseButton;
